import React, { useState, useEffect } from "react";
import {
  AppBar,
  IconButton,
  Typography,
  Drawer,
  List,
  Stack,
  Container,
  Box,
  styled,
  Badge,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Avatar,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import MenuIcon from "@mui/icons-material/Menu";
import logo from "../asset/TIE_LOGO.png";
import phone from "../asset/phone.svg";
import CloseIcon from "@mui/icons-material/Close";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import useMediaQuery from "@mui/material/useMediaQuery";
import { Grid } from "@material-ui/core";
import "../../src/index.css";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { Icon } from "@iconify/react";
import Popover from "@mui/material/Popover";
import PopupState, { bindTrigger, bindPopover } from "material-ui-popup-state";
import { MenuJson } from "./dashboard/navbar/NavBarJson";

const homeSubMenues = [
  { title: "About Us", link: "/aboutus" },
  { title: "Blogs", url: "https://blog.taksheela.com/" },
  { title: "Taksheela Edge", link: "/", id: "taksheela-edge-section" },
  { title: "Taksheela Insights", link: "/", id: "taksheela-insights-section" },
];

const studyAbroadsubMenues = [
  { title: "Test Prep", link: "/test" },
  { title: "Countries", link: "/study-abroad/country" },
  { title: "University Finder", link: "/study-abroad/universityFinder" },
];

const immersionSubMenues = [
  { title: "Middle East", link: "/immersion/middle-east" },
  { title: "South East Asia", link: "/immersion/southeast-asia" },
  { title: "Europe", link: "/immersion/europe" },
];

const iRSubMenues = [
  {
    title: "International Student Recruitment",
    link: "/international-relation",
    id: "international-student-recruitment",
  },
  {
    title: "Global Immersion",
    link: "/international-relation",
    id: "global-immersion",
  },
  {
    title: "Student Exchange Semester Abroad",
    link: "/international-relation",
    id: "student-exchange-semester-abroad",
  },
  {
    title: "Collaborative Research & Seminars",
    link: "/international-relation",
    id: "collaborative-research-seminars",
  },
  {
    title: "Dual degree/Joint degree & Twinning Programmes",
    link: "/international-relation",
    id: "twinning-programmes",
  },
  {
    title: "Internship Opportunities",
    link: "/international-relation",
    id: "internship-opportunities",
  },
];

const Navbar = ({ setItemUpdate, itemupdate }) => {
  const StyledBadge = styled(Badge)(({ theme }) => ({
    "& .MuiBadge-badge": {
      right: -3,
      top: { md: 13, xs: 5 },
      border: `2px solid ${theme.palette.background.paper}`,
      padding: "0 4px",
    },
  }));

  const navigate = useNavigate();
  const location = useLocation();
  const [cartList, setCartList] = useState();
  const [iftoken, setIfToken] = useState(false);
  const profileImg = sessionStorage.getItem("profileImg");

  const currentLocation = useLocation();
  const [expanded, setExpanded] = useState(null);

  const handleAccordionChange = (index) => {
    setExpanded(expanded === index ? null : index);
  };

  useEffect(() => {
    MenuJson.forEach((menuItem, index) => {
      if (
        menuItem.subMenu.some(
          (subItem) => currentLocation.pathname === subItem.link
        )
      ) {
        setExpanded(index); // Set expanded index
      }
    });
  }, [currentLocation.pathname]);

  useEffect(() => {
    const fetchCartData = async () => {
      const token = sessionStorage.getItem("authToken");
      if (token) {
        setIfToken(true);
        try {
          const response = await axios.get(
            `${process.env.REACT_APP_BASE_URL}order/get-cart`,
            {
              headers: {
                Authorization: token,
              },
            }
          );
          const data = response.data;
          if (data.success) {
            const apiCartList = data.data.flatMap((order) =>
              order.items.map((item) => ({
                id: item._id,
                title: item.planName,
                packagePrice: item.amount,
                planId: item.planId,
              }))
            );
            setCartList(apiCartList);
          }
        } catch (error) {
          console.error("Error fetching cart data:", error);
        }
      } else {
        const localCart = JSON.parse(sessionStorage.getItem("cart")) || [];
        setCartList(localCart);
      }
    };

    fetchCartData();
  }, [itemupdate]);

  const [drawerOpen, setDrawerOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const isSmScreen = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  const isMediumScreen = useMediaQuery((theme) => theme.breakpoints.down("md"));
  const [homeSubMenuOpen, setHomeSubMenuOpen] = useState(false);
  const [studyAbroadOpen, setStudyAbroadOpen] = useState(false);
  const [immersionOpen, setImmersionOpen] = useState(false);
  const [iROpen, setIROpen] = useState(false);

  const handleDrawerOpen = () => {
    setDrawerOpen(true);
  };

  const handleDrawerClose = () => {
    setDrawerOpen(false);
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 600);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handlePhoneIconClick = () => {
    window.open(`tel:${+919831241212}`);
  };

  const HoverTypography = ({ children }) => (
    <Typography
      variant="h6"
      color="inherit"
      sx={{
        textDecoration: "none",
        underline: "none",
        border: "2px solid white",
        borderRadius: 2,
        padding: {
          xs: "5px 0px 5px 0px",
          sm: "5px 0px 5px 0px",
          md: "5px 8px 5px 8px",
          lg: "5px 20px 5px 20px",
        },
        fontSize: { xs: "14px", md: "14px", lg: "16px" },
        fontStyle: "normal",

        fontWeight: 500,
        lineHeight: "28px",
        letterSpacing: "0.2px",
        "&:hover": {
          color: "#00999e",
          cursor: "pointer",
        },
      }}
    >
      {children}
    </Typography>
  );

  const NavLinkCss = ({ isActive }) => {
    return {
      color: isActive ? "#00999e" : "",
      border: isActive ? "2px solid #00999e" : "",
      borderRadius: isActive ? 8 : "",
      position: "relative",
    };
  };

  const [logoutDialogOpen, setLogoutDialogOpen] = useState(false);

  const handleLogout = () => {
    setLogoutDialogOpen(true);
  };

  const confirmLogout = () => {
    sessionStorage.removeItem("token");

    setLogoutDialogOpen(false);
    navigate("/");
    window.location.reload();
  };

  const handleHomeMouseEnter = () => {
    setHomeSubMenuOpen(true);
  };

  const handleHomeMouseLeave = () => {
    setHomeSubMenuOpen(false);
  };

  const handleStudyAbroadEnter = () => {
    setStudyAbroadOpen(true);
  };
  const handleStudyAbroadLeave = () => {
    setStudyAbroadOpen(false);
  };

  const handleImmersionEnter = () => {
    setImmersionOpen(true);
  };
  const handleImmersionLeave = () => {
    setImmersionOpen(false);
  };

  const handleIREnter = () => {
    setIROpen(true);
  };
  const handleIRLeave = () => {
    setIROpen(false);
  };

  const [selectedParentMenu, setSelectedParentMenu] = useState(null);

  const isParentMenuSelected = (parentMenu) =>
    selectedParentMenu === parentMenu;

  const [activeSubMenu, setActiveSubMenu] = useState("");

  const handleSubMenuClick = (e, subMenu) => {
    e.preventDefault();

    if (subMenu.url) {
      window.open(subMenu.url, "_blank");
      return;
    }

    // if (subMenu.link && subMenu.id) {
    //   if (location.pathname === subMenu.link) {
    //     const section = document.getElementById(subMenu.id);
    //     if (section) {
    //       section.scrollIntoView({ behavior: "smooth" });
    //       setActiveSubMenu(subMenu.title);
    //        setDrawerOpen(false);
    //     }
    //   } else {
    //     navigate(subMenu.link, {
    //       state: { scrollTo: subMenu.id, subMenuTitle: subMenu.title },
    //     });
    //      setDrawerOpen(false);
    //   }
    //   return;
    // }
    if (subMenu.link && subMenu.id) {
      if (subMenu.link.startsWith("http")) {
        window.open(subMenu.link, "_blank");
        return;
      }

      if (location.pathname === subMenu.link) {
        const section = document.getElementById(subMenu.id);
        if (section) {
          section.scrollIntoView({ behavior: "smooth" });
          setActiveSubMenu(subMenu.title);
          setDrawerOpen(false);
        }
      } else {
        navigate(subMenu.link, {
          state: { scrollTo: subMenu.id, subMenuTitle: subMenu.title },
        });
        setDrawerOpen(false);
      }
      return;
    }

    if (subMenu.link) {
      if (subMenu.link.startsWith("http")) {
        window.open(subMenu.link, "_blank");
      } else {
        navigate(subMenu.link);
        setActiveSubMenu(subMenu.title);
      }
      return;
    }

    if (subMenu.id) {
      if (
        location.pathname === "/" ||
        location.pathname === "/international-relation"
      ) {
        const section = document.getElementById(subMenu.id);
        if (section) {
          section.scrollIntoView({ behavior: "smooth" });
          setActiveSubMenu(subMenu.title);
        }
      } else {
        navigate("/", {
          state: { scrollTo: subMenu.id, subMenuTitle: subMenu.title },
        });
      }
      return;
    }
  };

  useEffect(() => {
    if (location.state?.scrollTo) {
      setTimeout(() => {
        const section = document.getElementById(location.state.scrollTo);
        if (section) {
          section.scrollIntoView({ behavior: "smooth" });
          setActiveSubMenu(location.state.subMenuTitle);
        }
      }, 500);
      window.history.replaceState({}, document.title);
    } else {
      if (location.pathname === "/") {
        setActiveSubMenu("");
      } else {
        const activeMenu = homeSubMenues.find(
          (menu) => menu.link === location.pathname
        );
        setActiveSubMenu(activeMenu ? activeMenu.title : "");
      }
    }
  }, [location]);

  return (
    <>
      <AppBar
        position="static"
        color="default"
        sx={{ backgroundColor: "white" }}
      >
        <Container maxWidth={"xxl"}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "80px",
            }}
          >
            {isSmScreen || isMediumScreen ? (
              <Grid
                container
                spacing={2}
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <Grid item>
                  <NavLink to="/" className="custom-link">
                    <img width="150px" src={logo} alt="Logo" />
                  </NavLink>
                </Grid>

                <Grid Grid item>
                  <Box sx={{ display: "flex", flexDirection: "row" }}>
                    <IconButton aria-label="cart" sx={{ pr: "40px" }}>
                      <StyledBadge
                        badgeContent={cartList?.length}
                        color={"primary"}
                      >
                        <ShoppingCartIcon />
                      </StyledBadge>
                    </IconButton>
                    <IconButton
                      edge="start"
                      color="inherit"
                      aria-label="menu"
                      onClick={handleDrawerOpen}
                    >
                      <MenuIcon />
                    </IconButton>
                  </Box>
                </Grid>
              </Grid>
            ) : (
              <NavLink to="/" className="custom-link">
                <img width="150px" src={logo} alt="Logo" />
              </NavLink>
            )}

            {isSmScreen || isMediumScreen ? (
              <Drawer
                anchor="left"
                open={drawerOpen}
                onClose={handleDrawerClose}
                ModalProps={{ keepMounted: true }}
                sx={{
                  "& .MuiDrawer-paper": {
                    width:
                      isMobile || isSmScreen || isMediumScreen ? "60%" : 300,
                  },
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "1rem",
                  }}
                >
                  {(isSmScreen || isMediumScreen) && (
                    <NavLink
                      to="/"
                      className="custom-link"
                      onClick={handleDrawerClose}
                    >
                      <img width="150px" src={logo} alt="Logo" />
                    </NavLink>
                  )}
                  <IconButton
                    onClick={handleDrawerClose}
                    sx={{ alignSelf: "flex-start" }}
                  >
                    <CloseIcon sx={{ color: "#00999E" }} />
                  </IconButton>
                </Box>
                <List sx={{ padding: "0px 20px" }}>
                  {MenuJson.map((menuItem, index) => (
                    <Accordion
                      key={index}
                      disableGutters
                      elevation={0}
                      expanded={expanded === index}
                      onChange={() => handleAccordionChange(index)}
                      sx={{
                        borderBottom: "none",
                        boxShadow: "none",
                        "&:before": { display: "none" },
                      }}
                    >
                      <AccordionSummary
                        sx={{ px: 0 }}
                        expandIcon={<ExpandMoreIcon sx={{ zIndex: 100 }} />}
                      >
                        <Box onClick={() => navigate(menuItem.menu.link)}>
                          <Typography
                            sx={{
                              fontSize: "16px",
                              fontWeight: "500",
                              margin: "0px !important",
                              padding: "0px !important",
                              display: "flex",
                              alignItems: "center",
                              lineHeight: "1",
                            }}
                          >
                            {menuItem.menu.name}
                          </Typography>
                        </Box>
                      </AccordionSummary>
                      <AccordionDetails sx={{ fontSize: "14px" }}>
                        {menuItem.subMenu.map((subItem, subIndex) => {
                          const isActive = activeSubMenu === subItem.title;

                          return (
                            <Typography
                              key={subIndex}
                              sx={{
                                // fontSize: "12px",
                                // py: 0.5,
                                color: isActive ? "#00999e" : "inherit",
                                fontWeight: isActive ? "bold" : "normal",
                              }}
                            >
                              <NavLink
                                to={subItem.link || "/"}
                                key={subItem.title}
                                className="custom-link"
                                onClick={(e) => handleSubMenuClick(e, subItem)}
                                style={{
                                  color:
                                    activeSubMenu === subItem.title
                                      ? "#00999E"
                                      : "",
                                }}
                              >
                                <HoverTypography
                                  fontSize="12px"
                                  // fontWeight={500}
                                  border="4px solid white"
                                  style={{
                                    color:
                                      activeSubMenu === subItem.title
                                        ? "blue"
                                        : "inherit",
                                  }}
                                >
                                  {subItem.title}
                                </HoverTypography>
                              </NavLink>
                            </Typography>
                          );
                        })}
                      </AccordionDetails>
                    </Accordion>
                  ))}
                  <NavLink
                    to="/contact"
                    className="custom-link"
                    onClick={handleDrawerClose}
                  >
                    <HoverTypography
                      fontSize={{
                        xs: "14px",
                        sm: "16px",
                        md: "16px",
                        lg: "17px",
                      }}
                      fontWeight={500}
                      sx={{ width: "60px" }}
                    >
                      Contact Us
                    </HoverTypography>
                  </NavLink>
                  {iftoken === true ? (
                    <Box>
                      <NavLink
                        to="/dashboard/home"
                        className="custom-link"
                        onClick={handleDrawerClose}
                      >
                        <HoverTypography
                          fontSize={{
                            xs: "14px",
                            sm: "16px",
                            md: "16px",
                            lg: "17px",
                          }}
                          fontWeight={500}
                          sx={{ width: "60px" }}
                        >
                          Dashboard
                        </HoverTypography>
                      </NavLink>
                      <Box
                        className="custom-link"
                        onClick={() => {
                          handleLogout();
                          handleDrawerClose();
                        }}
                      >
                        <HoverTypography
                          fontSize={{
                            xs: "14px",
                            sm: "16px",
                            md: "16px",
                            lg: "17px",
                          }}
                          fontWeight={500}
                          sx={{ width: "60px" }}
                        >
                          Log Out
                        </HoverTypography>
                      </Box>
                    </Box>
                  ) : (
                    <NavLink
                      to="/login"
                      className="custom-link"
                      onClick={handleDrawerClose}
                    >
                      <HoverTypography
                        fontSize={{
                          xs: "14px",
                          sm: "16px",
                          md: "16px",
                          lg: "17px",
                        }}
                        fontWeight={500}
                        sx={{ width: "60px" }}
                      >
                        Login
                      </HoverTypography>
                    </NavLink>
                  )}
                </List>
              </Drawer>
            ) : (
              <Box
                direction={{ xs: "column", sm: "row" }}
                spacing={{ xs: 2, md: 4, sm: 4 }}
                display="flex"
                justifyContent="center"
                alignItems="center"
                flexGrow={1}
                paddingTop={1}
                paddingBottom={1}
              >
                <NavLink
                  to="/"
                  onMouseEnter={handleHomeMouseEnter}
                  onMouseLeave={handleHomeMouseLeave}
                  className="custom-link"
                  style={({ isActive }) =>
                    NavLinkCss({
                      isActive: isParentMenuSelected("Home") || isActive,
                    })
                  }
                  onClick={() => setSelectedParentMenu("Home")}
                >
                  <HoverTypography
                    fontSize={{
                      xs: "10px",
                      sm: "10px",
                      md: "13px",
                      lg: "20px",
                    }}
                    fontWeight={500}
                    border="4px solid white"
                    isActive={isParentMenuSelected("Home")}
                  >
                    Home
                  </HoverTypography>

                  {homeSubMenuOpen && (
                    <Box
                      position="absolute"
                      left="0"
                      bgcolor="white"
                      boxShadow={3}
                      zIndex={999999}
                    >
                      {homeSubMenues.map((subMenu) => (
                        <NavLink
                          to={subMenu.link || "/"}
                          key={subMenu.title}
                          className="custom-link"
                          onClick={(e) => handleSubMenuClick(e, subMenu)}
                          style={{
                            color:
                              activeSubMenu === subMenu.title ? "#00999E" : "",
                          }}
                        >
                          <HoverTypography
                            fontSize={{
                              xs: "10px",
                              sm: "10px",
                              md: "13px",
                              lg: "15px",
                            }}
                            fontWeight={500}
                            border="4px solid white"
                            style={{
                              color:
                                activeSubMenu === subMenu.title
                                  ? "blue"
                                  : "inherit",
                            }}
                          >
                            {subMenu.title}
                          </HoverTypography>
                        </NavLink>
                      ))}
                    </Box>
                  )}
                </NavLink>

                <NavLink
                  to="/study-abroad"
                  className="custom-link"
                  style={NavLinkCss}
                  onMouseEnter={handleStudyAbroadEnter}
                  onMouseLeave={handleStudyAbroadLeave}
                >
                  <HoverTypography
                    fontSize={{
                      xs: "10px",
                      sm: "10px",
                      md: "13px",
                      lg: "15px",
                    }}
                    border="4px solid white"
                    fontWeight={500}
                  >
                    Study Abroad
                  </HoverTypography>
                  {studyAbroadOpen && (
                    <Box
                      position="absolute"
                      left="0"
                      bgcolor="white"
                      boxShadow={3}
                      zIndex={999999}
                    >
                      {studyAbroadsubMenues.map((subMenu) => (
                        <NavLink
                          to={subMenu.link}
                          key={subMenu.title}
                          className="custom-link"
                          style={{
                            color:
                              location.pathname === subMenu.link
                                ? "#00999e"
                                : "",
                          }}
                        >
                          <HoverTypography
                            fontSize={{
                              xs: "10px",
                              sm: "10px",
                              md: "13px",
                              lg: "15px",
                            }}
                            fontWeight={500}
                            border="4px solid white"
                            style={{
                              color:
                                location.pathname === subMenu.link
                                  ? "#00999e"
                                  : "",
                            }}
                          >
                            {subMenu.title}
                          </HoverTypography>
                        </NavLink>
                      ))}
                    </Box>
                  )}
                </NavLink>

                <NavLink
                  to="/international-relation"
                  className="custom-link"
                  style={NavLinkCss}
                  onMouseEnter={handleIREnter}
                  onMouseLeave={handleIRLeave}
                >
                  <HoverTypography
                    fontSize={{
                      xs: "10px",
                      sm: "10px",
                      md: "13px",
                      lg: "20px",
                    }}
                    border="4px solid white"
                    fontWeight={500}
                  >
                    International Engagement
                  </HoverTypography>
                  {iROpen && (
                    <Box
                      position="absolute"
                      left="0"
                      bgcolor="white"
                      boxShadow={3}
                      zIndex={999999}
                    >
                      {iRSubMenues.map((subMenu) => (
                        <NavLink
                          to={subMenu.link || "/international-relation"}
                          key={subMenu.title}
                          className="custom-link"
                          onClick={(e) => handleSubMenuClick(e, subMenu)}
                          style={{
                            color:
                              activeSubMenu === subMenu.title ? "#00999E" : "",
                          }}
                        >
                          <HoverTypography
                            fontSize={{
                              xs: "10px",
                              sm: "10px",
                              md: "13px",
                              lg: "15px",
                            }}
                            fontWeight={500}
                            border="4px solid white"
                            style={{
                              color:
                                activeSubMenu === subMenu.title
                                  ? "blue"
                                  : "inherit",
                            }}
                          >
                            {subMenu.title}
                          </HoverTypography>
                        </NavLink>
                      ))}
                    </Box>
                  )}
                </NavLink>

                <NavLink
                  to="/immersion"
                  className="custom-link"
                  style={NavLinkCss}
                  onMouseEnter={handleImmersionEnter}
                  onMouseLeave={handleImmersionLeave}
                >
                  <HoverTypography
                    fontSize={{
                      xs: "10px",
                      sm: "10px",
                      md: "13px",
                      lg: "20px",
                    }}
                    border="4px solid white"
                    fontWeight={500}
                  >
                    Immersion
                  </HoverTypography>

                  {immersionOpen && (
                    <Box
                      position="absolute"
                      left="0"
                      bgcolor="white"
                      boxShadow={3}
                      zIndex={999999}
                    >
                      {immersionSubMenues.map((subMenu) => (
                        <NavLink
                          to={subMenu.link}
                          key={subMenu.title}
                          className="custom-link"
                          style={{
                            color:
                              location.pathname === subMenu.link
                                ? "#00999e"
                                : "",
                          }}
                        >
                          <HoverTypography
                            fontSize={{
                              xs: "10px",
                              sm: "10px",
                              md: "13px",
                              lg: "15px",
                            }}
                            fontWeight={500}
                            border="4px solid white"
                            style={{
                              color:
                                location.pathname === subMenu.link
                                  ? "#00999e"
                                  : "",
                            }}
                          >
                            {subMenu.title}
                          </HoverTypography>
                        </NavLink>
                      ))}
                    </Box>
                  )}
                </NavLink>
                {iftoken === true ? (
                  <Box
                    sx={{
                      padding: {
                        xs: "5px 0px 5px 0px",
                        sm: "5px 0px 5px 0px",
                        md: "5px 8px 5px 8px",
                        lg: "5px 20px 5px 20px",
                      },
                    }}
                  >
                    <PopupState variant="popover" popupId="demo-popup-popover">
                      {(popupState) => (
                        <div>
                          <Button {...bindTrigger(popupState)}>
                            {profileImg === null ? (
                              <Icon
                                icon="carbon:user-avatar-filled"
                                fontSize={"36px"}
                                color="#00999E"
                              />
                            ) : (
                              <Box
                                sx={{
                                  borderRadius: "50%",
                                  overflow: "hidden",
                                  border: "1px solid #00999E",
                                  boxShadow: 10,

                                  width: "40px",
                                  height: "40px",
                                }}
                              >
                                <Avatar
                                  src={profileImg}
                                  sx={{ width: "38px", height: "38px" }}
                                />
                              </Box>
                            )}
                          </Button>
                          <Popover
                            {...bindPopover(popupState)}
                            anchorOrigin={{
                              vertical: "bottom",
                              horizontal: "center",
                            }}
                            transformOrigin={{
                              vertical: "top",
                              horizontal: "center",
                            }}
                          >
                            <NavLink
                              to="/dashboard/home"
                              className="custom-link"
                            >
                              {" "}
                              <HoverTypography
                                fontSize={{
                                  xs: "10px",
                                  sm: "10px",
                                  md: "13px",
                                  lg: "20px",
                                }}
                                border="4px solid white"
                                fontWeight={500}
                              >
                                Dashboard
                              </HoverTypography>
                            </NavLink>
                            <Box className="custom-link" onClick={handleLogout}>
                              <HoverTypography
                                fontSize={{
                                  xs: "10px",
                                  sm: "10px",
                                  md: "13px",
                                  lg: "20px",
                                }}
                                border="4px solid white"
                                fontWeight={500}
                              >
                                Log Out
                              </HoverTypography>
                            </Box>
                          </Popover>
                        </div>
                      )}
                    </PopupState>
                  </Box>
                ) : (
                  <NavLink
                    to="/login"
                    className="custom-link"
                    style={NavLinkCss}
                  >
                    {" "}
                    <HoverTypography
                      fontSize={{
                        xs: "10px",
                        sm: "10px",
                        md: "13px",
                        lg: "20px",
                      }}
                      border="4px solid white"
                      fontWeight={500}
                    >
                      Login
                    </HoverTypography>
                  </NavLink>
                )}
              </Box>
            )}
            {!isSmScreen && !isMediumScreen && (
              <Box
                direction={{ xs: "column", sm: "row" }}
                display="flex"
                justifyContent="center"
                alignItems="center"
                pr={"20px"}
              >
                <Stack direction="row">
                  <NavLink to="/addCart" className="custom-link">
                    <Badge badgeContent={cartList?.length} color="secondary">
                      <ShoppingCartIcon color="action" />
                    </Badge>
                  </NavLink>
                </Stack>
              </Box>
            )}

            {!isSmScreen && !isMediumScreen && (
              <Box>
                <HoverTypography>
                  <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                  >
                    <Stack
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                    >
                      <img
                        src={phone}
                        style={{ width: "2.5rem" }}
                        alt="Phone"
                      />
                    </Stack>
                    <Stack ml={1} onClick={handlePhoneIconClick}>
                      <Typography sx={{ color: "grey" }}>
                        Say Hello !
                      </Typography>
                      <Typography>+91 9831241212</Typography>
                    </Stack>
                  </Box>
                </HoverTypography>
              </Box>
            )}
          </Box>
        </Container>
      </AppBar>
      <Dialog
        open={logoutDialogOpen}
        onClose={() => setLogoutDialogOpen(false)}
        sx={{
          "& .MuiDialog-paper": {
            width: { sm: "450px", xs: "300px" },
          },
        }}
      >
        <DialogTitle>Confirm Logout</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to logout?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            onClick={() => setLogoutDialogOpen(false)}
            color="primary"
          >
            Cancel
          </Button>
          <Button variant="contained" onClick={confirmLogout} color="error">
            Logout
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default Navbar;
